// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';

//methods to mix into trace nodes
//A trace nodes has several trace properties and it's prototype is the corresponding feature
myw.TraceNodeMixin = {
    tooltip() {
        return `<dl><dd class='result-title'>${this.getTitle()}</dd><dd>${this.getShortDescription()}</dd><dd>${this.metadata().join(
            '</dd><dd>'
        )}</dd></dl>`;
    },

    metadata() {
        const metadata = this.traceResult.metadata.map(propName => {
            const val = this[propName];
            if (typeof val == 'undefined') return;

            if (propName == 'dist') {
                const defaultUnit = myw.applicationDefinition.displayUnits.length;
                const lengthConfig = myw.config['core.units'].length;
                const unitScale = new myw.UnitScale(lengthConfig);
                const unit = unitScale.value(val, 'm');
                return `${myw.msg('TracePlugin', 'distance_key')}: ${unit.toString(defaultUnit)}`;
            }

            //When no localisation is found
            const localisedPropName = myw.msg('TracePlugin', propName);
            if (localisedPropName.indexOf('TracePlugin.') == 0) {
                const propNameDisplay = propName.charAt(0).toUpperCase() + propName.slice(1);
                return `${propNameDisplay.replace(/_/gi, ' ')}: ${val}`;
            }
            return `${localisedPropName}: ${val}`;
        });
        return _.compact(metadata);
    },

    /**
     * Augments each traceNode with a spine identifier and returns a list of traceNodes representing the spine.        *
     * @return {Array} Returns an array representing the root spine (Longest path)
     */
    buildSpine() {
        let spine = [];
        let leaves = this.getLeaves();

        leaves = _.sortBy(leaves, 'dist').reverse();

        for (let i = 0; i < leaves.length; i++) {
            const branch = this._buildSpineFromEdge(leaves[i], []);

            for (let x = 0; x < branch.length; x++) {
                if (null == branch[x].spine) {
                    branch[x].spine = i;
                }
            }

            if (i == 0) {
                spine = branch;
            }
        }
        return spine;
    },

    _buildSpineFromEdge(node, spine) {
        const parent = node.parent;

        spine.unshift(node);
        if (parent) {
            this._buildSpineFromEdge(parent, spine);
        }
        return spine;
    },

    /**
     *   Find all leaf nodes from a starting node
     *
     **/
    getLeaves() {
        const leaves = [];
        this._findLeaves(this, leaves);
        return leaves;
    },

    _findLeaves(node, edges) {
        if (node.children.length) {
            for (let i = 0; i < node.children.length; i++) {
                this._findLeaves(node.children[i], edges);
            }
            return;
        }

        edges.push(node);
    }
};

export default myw.TraceNodeMixin;
